import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
